import { clientPortalRequest, buildClientQuery } from "./clientPortalFetch";

export function listClientViewSettingsDataSources(clientViewId) {
  return clientPortalRequest(`/views/${clientViewId}/settings/data-sources`);
}

export function updateClientViewVendorSearchSource(clientViewId, sourceId, enabled) {
  return clientPortalRequest(`/views/${clientViewId}/settings/data-sources/vendor-searches/${sourceId}`, {
    method: "PATCH",
    body: JSON.stringify({ enabled }),
  });
}

export function runClientViewVendorSearchSource(clientViewId, sourceId) {
  return clientPortalRequest(
    `/views/${clientViewId}/settings/data-sources/vendor-searches/${encodeURIComponent(sourceId)}/run`,
    { method: "POST" }
  );
}

export function previewClientViewVendorSearchSourceDeletion(clientViewId, sourceId) {
  return clientPortalRequest(
    `/views/${clientViewId}/settings/data-sources/vendor-searches/${encodeURIComponent(sourceId)}/deletion-preview`
  );
}

export function deleteClientViewVendorSearchSource(clientViewId, sourceId) {
  return clientPortalRequest(
    `/views/${clientViewId}/settings/data-sources/vendor-searches/${encodeURIComponent(sourceId)}`,
    { method: "DELETE" }
  );
}

export function updateClientViewListingSource(clientViewId, sourceKey, enabled) {
  return clientPortalRequest(
    `/views/${clientViewId}/settings/data-sources/listings/${encodeURIComponent(sourceKey)}`,
    {
      method: "PATCH",
      body: JSON.stringify({ enabled }),
    }
  );
}

export function runClientViewListingSource(clientViewId, sourceKey) {
  return clientPortalRequest(
    `/views/${clientViewId}/settings/data-sources/listings/${encodeURIComponent(sourceKey)}/run`,
    { method: "POST" }
  );
}

export function getClientViewListingSourceRun(clientViewId, sourceKey, runId) {
  return clientPortalRequest(
    `/views/${clientViewId}/settings/data-sources/listings/${encodeURIComponent(sourceKey)}/runs/${encodeURIComponent(runId)}`
  );
}

export function listClientViewSettingsAuditLog(clientViewId, params = {}) {
  return clientPortalRequest(
    `/views/${clientViewId}/settings/audit-log${buildClientQuery(params)}`
  );
}
